import React from "react";
import { Modal } from "react-bootstrap";
import {
  ActionIconContainer,
  AddFormButton,
  FilterButton,
} from "../TableElements";
import { useTranslation } from "react-i18next";

const TemplateConfirmationPopup = ({
  show,
  onHide,
  onConfirm,
  title,
  message,
  confirmLabel,
}) => {
  const { t } = useTranslation("common");

  return (
    <Modal show={show} onHide={onHide} size="sm" centered>
      <Modal.Header style={{ borderBottom: "none", paddingBottom: 0 }}>
        <Modal.Title style={{ fontSize: "18px", fontWeight: 500 }}>
          {title}
        </Modal.Title>
        <ActionIconContainer
          onClick={onHide}
          id="close-action-popup-icon-container"
        >
          <i className="fi fi-rr-cross-small" id="close-action-popup-icon" />
        </ActionIconContainer>
      </Modal.Header>
      <Modal.Body style={{ paddingTop: "10px", paddingBottom: "20px" }}>
        <p style={{ fontSize: "14px", marginBottom: 0 }}>{message}</p>
      </Modal.Body>
      <Modal.Footer style={{ borderTop: "none", padding: "0 15px 15px 15px" }}>
        <div className="d-flex justify-content-end gap-2 w-100">
          <FilterButton onClick={onHide}>{t("cancel")}</FilterButton>
          <AddFormButton onClick={onConfirm}>
            {confirmLabel || t("apply")}
          </AddFormButton>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default TemplateConfirmationPopup;
